import React from "react";
import classNames from "classnames";

const ButtonUncontained = ({
  id,
  dataCy,
  text,
  type = "default",
  disabled = false,
  onClick,
  buttonType = "button"
}) => {
  const baseStyles =
    "flex items-center justify-center transition-all duration-200 font-outfit text-[16px] font-semibold h-12";
  const typeStyles = {
    default: disabled
      ? "text-[var(--color-gray-400)] cursor-not-allowed opacity-50"
      : "text-[var(--color-gray-800)] hover:text-black",

    alt: disabled
      ? "text-[var(--color-gray-400)] cursor-not-allowed opacity-50"
      : "text-[var(--color-blue-600)] hover:bg-[var(--color-gray-50)] rounded-full px-6 py-[14px]",

    large: disabled
      ? "text-[var(--color-gray-400)] text-[20px] cursor-not-allowed opacity-50"
      : "text-[var(--color-gray-600)] text-[20px] hover:text-black",
  };

  return (
    <button
      id={id}
      data-cy={dataCy}
      className={classNames(baseStyles, typeStyles[type])}
      onClick={onClick}
      disabled={disabled}
      type={buttonType}
    >
      {text}
    </button>
  );
};

export default ButtonUncontained;